<template>
  <v-snackbar
    v-model="visivel"
    :timeout="-1"
    location="bottom"
    color="primary"
    multi-line
  >
    {{ $t('update_notice.message') }}

    <template #actions>
      <v-btn variant="text" :loading="recarregando" @click="atualizar">
        {{ $t('update_notice.update') }}
      </v-btn>
      <v-btn variant="text" @click="visivel = false">{{ $t('update_notice.later') }}</v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { EVENTO_ATUALIZACAO } from '../../registerServiceWorker'

/**
 * Avisa que existe build novo esperando, e dá o botão que aplica.
 *
 * ------------------------------------------------------------------- POR QUE
 *
 * O service worker do `@vue/cli-plugin-pwa` faz precache do app e continua
 * servindo o `index.html` ANTIGO até que todas as abas do site sejam fechadas.
 * Como aquele HTML referencia bundles com hash antigo — que somem na publicação
 * nova —, o resultado não é "ver a versão velha", é **tela em branco**.
 *
 * O gancho `updated()` sempre soube disso e só escrevia no console. Este
 * componente é a tela que faltava.
 *
 * -------------------------------------------------- POR QUE NÃO RECARREGAR SÓ
 *
 * `skipWaiting` automático resolveria sem interação, e foi descartado de
 * propósito: trocaria o app debaixo de quem está no meio de lançar uma súmula —
 * a tela mais sensível do produto, e a que fica aberta por mais tempo. Perder um
 * placar por causa de um deploy é pior que ver um aviso.
 *
 * Por isso `timeout: -1` (não some sozinho) e um "Agora não": o aviso espera a
 * pessoa, e volta no próximo carregamento se ela adiar.
 */
export default {
  name: 'AvisoDeAtualizacao',

  data () {
    return {
      visivel: false,
      recarregando: false,
      registration: null
    }
  },

  mounted () {
    window.addEventListener(EVENTO_ATUALIZACAO, this.aoDetectarAtualizacao)
  },

  // O componente vive no App e não desmonta na prática, mas remover o listener
  // é o que impede um vazamento em teste e em hot reload.
  beforeUnmount () {
    window.removeEventListener(EVENTO_ATUALIZACAO, this.aoDetectarAtualizacao)
  },

  methods: {
    aoDetectarAtualizacao (evento) {
      this.registration = evento.detail && evento.detail.registration
      this.visivel = true
    },

    atualizar () {
      this.recarregando = true

      const emEspera = this.registration && this.registration.waiting

      // Sem service worker em espera não há o que ativar — recarregar direto
      // ainda resolve, porque o `index.html` volta a ser buscado.
      if (!emEspera) {
        window.location.reload()
        return
      }

      // Recarrega quando o controle passar para o worker novo. Sem esperar por
      // isso, o reload é servido pelo worker ANTIGO e o usuário continua na
      // mesma versão — com a diferença de agora achar que atualizou.
      //
      // `{ once: true }` porque `controllerchange` também dispara em outras
      // situações, e recarregar em laço é o pior desfecho possível aqui.
      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => window.location.reload(),
        { once: true }
      )

      emEspera.postMessage({ type: 'SKIP_WAITING' })

      // Rede de segurança: se o worker não responder ao SKIP_WAITING (versão
      // antiga do plugin, worker travado), o botão ficaria girando para sempre.
      setTimeout(() => window.location.reload(), 3000)
    }
  }
}
</script>
